<template>
  <button
    :aria-label="active ? t('menu.close') : t('menu.open')"
    class="hamburger"
  >
    <span v-for="i in 3" :key="i" class="bar" />
  </button>
</template>

<script lang="ts" setup>
withDefaults(defineProps<{ active: boolean }>(), { active: false })

const { t } = useI18n()
</script>

<style lang="scss" scoped>
.hamburger {
  @include focus-visible;
  @include size(60px);
  @include center-content;
  flex-direction: column;
  flex-shrink: 0;
  gap: rem(5px);

  background-color: $layout-background-02;
  border-radius: 50%;
  box-shadow: $base-shadow;
}

.bar {
  display: block;
  width: rem(22px);
  height: rem(1px);
  background-color: $black-hex;
}
</style>
